export default "__VITE_ASSET__HNobVd8M__"